export const dayAttendanceDTOFields = {
    type: 'type',
    entryTime: 'entryTime',
    exitTime: 'exitTime',
} as const;
